export const INITIAL_STATE = {
  data: {isUpdatingEquipment: false, segurado_bicicletas: []},
  extra_data: {},
  lock: true,
  current: 0,
  error: '',
  is_advance: true,
  render: false,
  submiting: false,
  success_submit: false,
  submiting_segurado: false,
  sending_link: false,
  canAdvance: true,
  canRegress: true,
  canSubmit: false,
};

export const actions = {
  RENDER: 'RENDER',
  ADVANCE: 'ADVANCE',
  GO_TO: 'GO_TO',
  REGRESS: 'REGRESS',
  CLEAN_ERROR: 'CLEAN_ERROR',
  ERROR_SUBMIT: 'ERROR_SUBMIT',
  START_SUBMIT: 'START_SUBMIT',
  START_SUBMIT_SEGURADO: 'START_SUBMIT_SEGURADO',
  SUCCESS_SUBMIT: 'SUCCESS_SUBMIT',
  CHANGE_BUTTON_STATUS: 'CHANGE_BUTTON_STATUS',
  CHANGE_ADVANCE_STATUS: 'CHANGE_ADVANCE_STATUS',
  BIKE_ERROR: 'BIKE_ERROR',
  ADD_EQUIPMENT: 'ADD_EQUIPMENT',
  REMOVE_EQUIPMENT: 'REMOVE_EQUIPMENT',
  SET_BIKE_ID: 'SET_BIKE_ID',
  SUCCESS_SUBMIT_FOTOS: 'SUCCESS_SUBMIT_FOTOS',
  SET_EQUIPMENT_TO_UPDATE: 'SET_EQUIPMENT_TO_UPDATE',
  SET_TOTAL_TO_BIKE: 'SET_TOTAL_TO_BIKE',
};

export const reducer = (state, {type, payload}) => {
  switch (type) {
    case actions.RENDER:
      return {...state, render: true, lock: false, extra_data: payload};

    case actions.ADVANCE: {
      const temp = {};
      let current = state.current + 1;

      switch (payload?.caller) {
        case 'MODAL_CHOICE':
          temp.data = {...state.data, ...payload.data};
          break;
        case 'SEGURADO_BASIC':
          temp.data = {...state.data, ...payload.data};
          break;
        case 'BIKE':
          temp.data = {...state.data, ...payload.data};
          break;
        case 'COBERTURA':
          temp.data = {...state.data, ...payload.data};
          break;
        case 'SEGURADO':
          temp.data = {...state.data, ...payload.data};
          break;
        case 'DADOS':
          temp.data = {...state.data, ...payload.data};
          break;
        case 'PAGAMENTO':
          temp.data = {...state.data, ...payload.data};
          temp.canSubmit = true;
          break;
        case 'FOTO':
          // current--;
          // temp.submiting_segurado = true;
          // temp.canAdvance = false;
          temp.data = {...state.data, ...payload.data};
          break;
        default:
          temp.data = {...state.data, ...payload.data};
      }

      return {...state, is_advance: true, current, ...temp};
    }

    case actions.BIKE_ERROR: {
      return {...state, current: state.current - 1};
    }

    case actions.GO_TO:
      return {...state, current: payload};

    case actions.REGRESS:
      return {...state, is_advance: false, current: state.current - 1};

    case actions.CHANGE_BUTTON_STATUS: {
      if (payload.status !== (state.canAdvance || state.canRegress))
        return {...state, canAdvance: payload.status, canRegress: payload.status};
      return state;
    }

    case actions.CHANGE_ADVANCE_STATUS: {
      if (payload.status !== state.canAdvance) return {...state, canAdvance: payload.status};
      return state;
    }

    case actions.START_SUBMIT:
      return {...state, submiting: true, canAdvance: false, data: {...state.data, ...payload}};

    case actions.START_SUBMIT_SEGURADO:
      return {...state, submiting_segurado: true, canAdvance: false, data: {...state.data, ...payload}};

    case actions.SUCCESS_SUBMIT:
      return {
        ...state,
        submiting: false,
        submiting_segurado: false,
        success_submit: true,
        extra_data: {
          ...state.extra_data,
          ...payload,
        },
      };

    case actions.ERROR_SUBMIT:
      return {...state, submiting: false, submiting_segurado: false, canAdvance: true, error: payload};

    case actions.CLEAN_ERROR:
      return {...state, error: ''};

    case actions.ADD_EQUIPMENT: {
      const bikeIndex = state.data.segurado_bicicletas.findIndex(
        (sb) => sb.numero_serie === state.data.segurado_bicicleta.numero_serie,
      );

      if (state.data.isUpdatingEquipment && bikeIndex !== -1) {
        let newBikes = JSON.parse(JSON.stringify(state.data.segurado_bicicletas));
        newBikes[bikeIndex] = {...state.data.segurado_bicicleta, coberturas: state.data.cobertura};

        return {
          ...state,
          current: payload.current,
          data: {
            ...state.data,
            isUpdatingEquipment: false,
            segurado_bicicletas: newBikes,
          },
        };
      }

      return {
        ...state,
        current: payload.current,
        data: {
          ...state.data,
          isUpdatingEquipment: false,
          segurado_bicicletas: [
            ...state.data.segurado_bicicletas,
            {...state.data.segurado_bicicleta, coberturas: state.data.cobertura},
          ],
        },
      };
    }

    case actions.SET_TOTAL_TO_BIKE: {
      return {
        ...state,
        data: {
          ...state.data,
          segurado_bicicleta: {
            ...state.data.segurado_bicicleta,
            total_coberturas: payload.total,
          },
        },
      };
    }

    case actions.SET_EQUIPMENT_TO_UPDATE: {
      const bike = state.data.segurado_bicicletas[payload.index];

      return {
        ...state,
        current: 3,
        data: {
          ...state.data,
          isUpdatingEquipment: true,
          segurado_bicicleta: {
            ...bike,
          },
          cobertura: {
            ...bike.coberturas,
          },
        },
      };
    }

    case actions.REMOVE_EQUIPMENT: {
      const bikes = [...state.data.segurado_bicicletas];
      bikes.splice(payload.index, 1);

      return {...state, data: {...state.data, segurado_bicicletas: bikes}};
    }

    case actions.SET_BIKE_ID: {
      return {...state, current: state.current + 1, data: {...state.data, bike_selecionada: payload}};
    }

    case actions.SUCCESS_SUBMIT_FOTOS: {
      const newBikes = [...state.extra_data.segurado.segurado_bicicletas];
      const index = newBikes.findIndex((b) => b.id === payload);
      newBikes[index] = {...newBikes[index], fotos_enviadas: true};

      return {
        ...state,
        current: state.current - 1,
        extra_data: {...state.extra_data, segurado: {...state.extra_data.segurado, segurado_bicicletas: newBikes}},
        submiting_segurado: false,
      };
    }

    default:
      return state;
  }
};
